import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from 'src/@smartmanufacturing/common/constants';

@Injectable({
  providedIn: 'root'
})
export class TechScoreService {
  
  
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }

  //NOT IN USE
  // getTechnicianList(data:any): Observable<any[]> {
  //   return this.http.get<any>(this.baseUrl + 'get-technician-list' , {params:data});
  // }

  getTechScoreList(data: any): Observable<any[]> {
    //return this.http.get<any>(this.baseUrl + 'getTechScore', { params: data });
    return this.http.get<any>(this.O3CoreApiUrl + 'PMTechScore/GetTechScoreList', { params: data });
  }

  createTechScore(data: any): Observable<any[]> {
    // return this.http.post<any>(this.baseUrl + 'createTechScore', data);
    return this.http.post<any>(this.O3CoreApiUrl + 'PMTechScore/createTechScore', data);
  }

  getTechnicianImageAndName(data: any): Observable<any[]> {
    return this.http.post<any>(this.O3CoreApiUrl + 'TechScore/getTechnicianImageAndName', data);
  }

  getAllTechScoreList(data: any): Observable<any[]> {
    return this.http.get<any>(this.O3CoreApiUrl + 'PMTechScore/GetAllTechScoreList', { params: data });
  }

}
